(() => {
  const RULES = [
['2XS',27,28.4,36,39.4,28,30.4,'standard'],
['XS',27,28.4,39.5,47.4,28,37.4,'quad'],
['XS',27,28.4,36,39.4,30.5,37.4,'calf'],
['XS',28.5,30.4,36,41.4,28,32.4,'standard'],
['S',28.5,30.4,41.5,49.4,28,39.4,'quad'],
['S',28.5,30.4,36,41.4,32.5,39.4,'calf'],
['S',30.5,32.4,36,43.4,28,34.4,'standard'],
['M',30.5,32.4,43.5,51.4,28,41.4,'quad'],
['M',30.5,32.4,36,43.4,34.5,41.4,'calf'],
['M',32.5,34.4,36,45.4,28,36.4,'standard'],
['L',32.5,34.4,45.5,53.4,28,43.4,'quad'],
['L',32.5,34.4,36,45.4,36.5,43.4,'calf'],
['L',34.5,36.4,36,47.4,28,38.4,'standard'],
['XL',34.5,36.4,47.5,56.4,28,45.4,'quad'],
['XL',34.5,36.4,36,47.4,38.5,45.4,'calf'],
['XL',36.5,38.4,36,49.4,28,40.4,'standard'],
['2XL',36.5,38.4,49.5,61,28,48.4,'quad'],
['2XL',36.5,38.4,36,49.4,40.5,48.4,'calf'],
['2XL',38.5,40.4,36,51.4,28,42.4,'standard'],
['3XL',38.5,40.4,51.5,61,28,50.4,'quad'],
['3XL',38.5,40.4,36,51.4,42.5,50.4,'calf'],
['3XL',40.5,42.4,36,53.4,28,44.4,'standard'],
['4XL',40.5,42.4,53.5,61,28,53,'quad'],
['4XL',40.5,42.4,36,53.4,44.5,53,'calf'],
['4XL',42.5,44.4,36,56.4,28,46.4,'standard'],
['5XL',42.5,44.4,56.5,61,28,53,'quad'],
['5XL',42.5,44.4,36,56.4,46.5,53,'calf'],
['5XL',44.5,47.4,36,61,28,49.4,'standard'],
['6XL',44.5,47.4,36,63,49.5,53,'calf'],
['6XL',47.5,53,36,61,28,53,'standard']
];

  const SIZES = ['2XS','XS','S','M','L','XL','2XL','3XL','4XL','5XL','6XL'];
  const RECOMMENDER_VERSION = 'RM-1.0';


  const RECOMMENDATION_STORAGE_KEY = 'a7_rigor_last_recommendation';
  const RECOMMENDATION_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;

  const getPageProductHandle = () => {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/i);
    return match ? match[1] : '';
  };

  const getPageProductTitle = () =>
    document.querySelector('h1.product-details-product-title, h1.product__title, main h1')?.textContent?.trim() || '';

  const getRecommendationSource = (root) => {
    if (getPageProductHandle()) return 'product-page';
    if (root.closest('[data-a7-rigor-promo-section], [data-a7-rigor-promo-modal]')) return 'collection-popup';
    if (window.location.pathname.includes('/blogs/')) return 'blog';
    return 'standalone-page';
  };

  const saveRecommendation = ({ root, knee, quad, calf, recommendedSize, reason, competitionFit }) => {
    const recommendation = {
      version: 1,
      recommenderVersion: RECOMMENDER_VERSION,
      recommendedSize,
      reason,
      knee,
      quad,
      calf,
      competitionFit: competitionFit || '',
      productHandle: getPageProductHandle(),
      productTitle: getPageProductTitle(),
      source: getRecommendationSource(root),
      createdAt: Date.now()
    };

    try {
      localStorage.setItem(RECOMMENDATION_STORAGE_KEY, JSON.stringify(recommendation));
    } catch (_) {}

    document.dispatchEvent(new CustomEvent('a7:rigor-recommendation', {
      detail: recommendation
    }));
  };

  const getStoredRecommendation = () => {
    try {
      const recommendation = JSON.parse(localStorage.getItem(RECOMMENDATION_STORAGE_KEY) || 'null');
      if (!recommendation?.recommendedSize || !recommendation?.createdAt) return null;
      if (Date.now() - Number(recommendation.createdAt) > RECOMMENDATION_MAX_AGE_MS) {
        localStorage.removeItem(RECOMMENDATION_STORAGE_KEY);
        return null;
      }
      return recommendation;
    } catch (_) {
      return null;
    }
  };

  const previousSize = (size) => {
    const index = SIZES.indexOf(size);
    return index > 0 ? SIZES[index - 1] : null;
  };

  const findRule = (knee, quad, calf) =>
    RULES.find((rule) =>
      knee >= rule[1] && knee <= rule[2] &&
      quad >= rule[3] && quad <= rule[4] &&
      calf >= rule[5] && calf <= rule[6]
    );

  const recommendationText = (type, size) => {
    if (type === 'quad') {
      return `Your quad measurement is larger than expected for your knee measurement. We recommend <strong>${size}</strong> for the best overall fit.`;
    }
    if (type === 'calf') {
      return `Your calf measurement is larger than expected for your knee measurement. We recommend <strong>${size}</strong> for the best overall fit.`;
    }
    return `Based on your measurements, we recommend <strong>${size}</strong>.`;
  };

  const initialise = (root) => {
    if (!root || root.dataset.initialised === 'true') return;
    root.dataset.initialised = 'true';

    const sectionId = root.dataset.sectionId;
    const byId = (id) => root.querySelector(`#${CSS.escape(id + '-' + sectionId)}`);

    const inputs = {
      knee: byId('knee'),
      quad: byId('quad'),
      calf: byId('calf')
    };

    const errors = {
      knee: byId('kneeError'),
      quad: byId('quadError'),
      calf: byId('calfError')
    };

    const calculateButton = byId('calculate');
    const generalError = byId('generalError');
    const result = byId('result');
    const sizeOutput = byId('size');
    const reasonOutput = byId('reason');
    const competitionSection = byId('competitionSection');
    const competitionSize = byId('competitionSize');
    const noCompetitionSection = byId('noCompetitionSection');
    const debugPanel = root.querySelector('[data-a7-rigor-debug]');
    const debugEnabled = new URLSearchParams(window.location.search).get('a7debug') === '1';
    if (debugPanel && debugEnabled) debugPanel.hidden = false;

    const clearValidation = () => {
      Object.keys(inputs).forEach((key) => {
        inputs[key].classList.remove('invalid');
        inputs[key].removeAttribute('aria-invalid');
        errors[key].textContent = '';
      });
      generalError.classList.remove('show');
      generalError.textContent = '';
    };

    const parseMeasurement = (value) => {
      const normalised = String(value || '')
        .trim()
        .replace(',', '.');

      if (!/^\d+(?:\.\d+)?$/.test(normalised)) {
        return null;
      }

      const number = Number(normalised);
      return Number.isFinite(number) ? number : null;
    };

    const validateField = (key, label) => {
      const input = inputs[key];
      const rawValue = input.value.trim();

      if (!rawValue) {
        input.classList.add('invalid');
        input.setAttribute('aria-invalid', 'true');
        errors[key].textContent = `Please enter your ${label.toLowerCase()} measurement.`;
        return null;
      }

      const value = parseMeasurement(rawValue);

      if (value === null) {
        input.classList.add('invalid');
        input.setAttribute('aria-invalid', 'true');
        errors[key].textContent = `Please enter a valid ${label.toLowerCase()} measurement in cm.`;
        return null;
      }

      const minimum = Number(input.dataset.min);
      const maximum = Number(input.dataset.max);

      if (value < minimum || value > maximum) {
        input.classList.add('invalid');
        input.setAttribute('aria-invalid', 'true');
        errors[key].textContent = `Please enter a ${label.toLowerCase()} measurement between ${minimum} and ${maximum} cm.`;
        return null;
      }

      return value;
    };

    const calculate = () => {
      clearValidation();
      result.classList.remove('show');

      const measurements = {
        knee: validateField('knee', 'Knee'),
        quad: validateField('quad', 'Quad'),
        calf: validateField('calf', 'Calf')
      };

      if (Object.values(measurements).includes(null)) {
        root.querySelector('input.invalid')?.focus();
        return;
      }

      const rule = findRule(
        measurements.knee,
        measurements.quad,
        measurements.calf
      );

      if (!rule) {
        const email = root.dataset.supportEmail || 'hello@a7uk.com';
        generalError.innerHTML =
          `These measurements do not match a standard recommendation. Please contact us at ` +
          `<a href="mailto:${email}">${email}</a> for individual sizing advice.`;
        generalError.classList.add('show');
        if (debugPanel && debugEnabled) {
          debugPanel.querySelector('[data-debug-measurements]').textContent = `${inputs.knee.value} / ${inputs.quad.value} / ${inputs.calf.value} cm`;
          debugPanel.querySelector('[data-debug-rule]').textContent = 'No matching rule';
          debugPanel.querySelector('[data-debug-reason]').textContent = 'No match';
          debugPanel.querySelector('[data-debug-size]').textContent = '—';
          debugPanel.querySelector('[data-debug-competition]').textContent = '—';
        }
        return;
      }

      const recommendedSize = rule[0];
      const reason = rule[7];
      const wasSizedUp = reason === 'quad' || reason === 'calf';
      const competitionFit = wasSizedUp ? previousSize(recommendedSize) : null;

      saveRecommendation({
        root,
        knee: measurements.knee,
        quad: measurements.quad,
        calf: measurements.calf,
        recommendedSize,
        reason,
        competitionFit
      });

      sizeOutput.textContent = recommendedSize;
      reasonOutput.innerHTML = recommendationText(reason, recommendedSize);
      competitionSection.style.display = 'none';
      noCompetitionSection.style.display = 'none';

      if (competitionFit) {
        competitionSize.textContent = competitionFit;
        competitionSection.style.display = 'block';
      } else if (recommendedSize !== '2XS') {
        noCompetitionSection.style.display = 'block';
      }

      if (debugPanel && debugEnabled) {
        const ruleIndex = RULES.indexOf(rule) + 1;
        debugPanel.querySelector('[data-debug-measurements]').textContent = `${inputs.knee.value} / ${inputs.quad.value} / ${inputs.calf.value} cm`;
        debugPanel.querySelector('[data-debug-rule]').textContent = `Rule ${ruleIndex}: knee ${rule[1]}–${rule[2]}, quad ${rule[3]}–${rule[4]}, calf ${rule[5]}–${rule[6]}`;
        debugPanel.querySelector('[data-debug-reason]').textContent = reason || 'standard';
        debugPanel.querySelector('[data-debug-size]').textContent = recommendedSize;
        debugPanel.querySelector('[data-debug-competition]').textContent = competitionFit || 'Not recommended';
      }

      result.classList.add('show');
      result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    };

    calculateButton.addEventListener('click', calculate);

    Object.keys(inputs).forEach((key) => {
      inputs[key].addEventListener('input', () => {
        inputs[key].classList.remove('invalid');
        inputs[key].removeAttribute('aria-invalid');
        errors[key].textContent = '';
      });
      inputs[key].addEventListener('keydown', (event) => {
        if (event.key === 'Enter') calculate();
      });
    });
  };

  const initialiseAll = () => {
    document.querySelectorAll('[data-a7-rigor-calculator]').forEach(initialise);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAll);
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialise(event.target.querySelector('[data-a7-rigor-calculator]'));
  });

  let lastModalTrigger = null;

  const getFocusable = (container) =>
    Array.from(container.querySelectorAll(
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter((element) => !element.hasAttribute('hidden'));

  const openModal = (modal, trigger) => {
    if (!modal) return;
    lastModalTrigger = trigger || null;
    modal.hidden = false;
    document.body.classList.add('a7-rigor-modal-open');
    const dialog = modal.querySelector('.a7-rigor-modal__dialog');
    requestAnimationFrame(() => dialog?.focus());
  };

  const closeModal = (modal) => {
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('a7-rigor-modal-open');
    lastModalTrigger?.focus();
    lastModalTrigger = null;
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-a7-rigor-open]');
    if (opener) {
      openModal(document.getElementById(opener.dataset.a7RigorOpen), opener);
      return;
    }

    const closer = event.target.closest('[data-a7-rigor-close]');
    if (closer) closeModal(closer.closest('[data-a7-rigor-modal]'));
  });

  document.addEventListener('keydown', (event) => {
    const modal = document.querySelector('[data-a7-rigor-modal]:not([hidden])');
    if (!modal) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal(modal);
      return;
    }

    if (event.key === 'Tab') {
      const focusable = getFocusable(modal);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });


  const normaliseOptionText = (value) =>
    String(value || '').trim().replace(/\s+/g, ' ').toLowerCase();

  const isRigorValue = (value, requiredValue = 'Rigor Mortis') =>
    normaliseOptionText(value) === normaliseOptionText(requiredValue);

  const optionNameIsStiffness = (value) =>
    normaliseOptionText(value).includes('stiffness');

  const getProductRoot = (section) =>
    section.closest('product-information') ||
    section.closest('[data-product-content-wrapper]') ||
    section.closest('.product-single-wrapper') ||
    document;

  const readSelectedStiffness = (section) => {
    const productRoot = getProductRoot(section);

    // Flow Eight normally keeps the selected value in the option heading,
    // for example “MATERIAL STIFFNESS: RIGOR MORTIS”.
    for (const swatch of productRoot.querySelectorAll('product-swatch')) {
      const label = swatch.querySelector('.label-font');
      const optionName = label?.dataset.option || label?.textContent?.split(':')[0] || '';
      if (!optionNameIsStiffness(optionName)) continue;

      const labelledValue = label?.textContent?.split(':').slice(1).join(':').trim();
      if (labelledValue) return labelledValue;

      const checked = swatch.querySelector('input:checked');
      if (checked) return checked.value || checked.dataset.value || '';

      const active = swatch.querySelector('.swatch-element.active, [aria-checked="true"]');
      if (active) {
        return active.dataset.value || active.querySelector('input')?.value || active.textContent || '';
      }
    }

    // Native radios and dropdowns.
    for (const input of productRoot.querySelectorAll('input[name^="options["]:checked')) {
      const name = input.name.match(/^options\[(.+)\]$/i)?.[1] || '';
      if (optionNameIsStiffness(name)) return input.value || input.dataset.value || '';
    }

    for (const select of productRoot.querySelectorAll('select[name^="options["]')) {
      const name = select.name.match(/^options\[(.+)\]$/i)?.[1] || '';
      if (optionNameIsStiffness(name)) return select.value || '';
    }

    // Generic fallback for Flow blocks whose markup varies by product.
    for (const container of productRoot.querySelectorAll('[data-product-options], .swatch, fieldset')) {
      const heading = container.querySelector('.label-font, legend, .header');
      const headingText = heading?.dataset.option || heading?.textContent || '';
      if (!optionNameIsStiffness(headingText)) continue;

      const headingValue = heading?.textContent?.split(':').slice(1).join(':').trim();
      if (headingValue) return headingValue;

      const selected = container.querySelector('input:checked, .swatch-element.active, [aria-checked="true"]');
      if (selected) return selected.value || selected.dataset.value || selected.textContent || '';
    }

    return '';
  };

  const findStiffnessWrapper = (section) => {
    const productRoot = getProductRoot(section);

    for (const swatch of productRoot.querySelectorAll('product-swatch')) {
      const label = swatch.querySelector('.label-font');
      const optionName = label?.dataset.option || label?.textContent?.split(':')[0] || '';
      if (optionNameIsStiffness(optionName)) return swatch;
    }

    for (const input of productRoot.querySelectorAll('input[name^="options["]')) {
      const name = input.name.match(/^options\[(.+)\]$/i)?.[1] || '';
      if (optionNameIsStiffness(name)) {
        return input.closest('fieldset, .swatch, .product-form-block, [data-product-options]');
      }
    }

    return null;
  };

  const portalModalToBody = (section) => {
    const modal = section._a7Modal;
    if (modal && modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
  };

  const positionProductTrigger = (section) => {
    const trigger = section._a7Trigger;
    const wrapper = findStiffnessWrapper(section);
    if (!trigger || !wrapper) return false;

    // Flow may replace the entire options block after a swatch click. Reinsert
    // the same trigger after the newly rendered stiffness selector each time.
    if (trigger.previousElementSibling !== wrapper) {
      wrapper.insertAdjacentElement('afterend', trigger);
    }
    return true;
  };

  const updateProductButtonVisibility = (section) => {
    if (!section) return;

    portalModalToBody(section);
    const positioned = positionProductTrigger(section);
    const selectedValue = readSelectedStiffness(section);
    const requiredValue = section.dataset.a7RigorOptionValue || 'Rigor Mortis';
    const show = positioned && isRigorValue(selectedValue, requiredValue);

    if (section._a7Trigger) section._a7Trigger.hidden = !show;
  };

  const bindProductSection = (section) => {
    if (!section || section.dataset.a7ProductBound === 'true') return;
    section.dataset.a7ProductBound = 'true';

    section._a7Trigger = section.querySelector('[data-a7-rigor-open]');
    section._a7Modal = section.querySelector('[data-a7-rigor-modal]');

    const opener = section._a7Trigger;
    const modal = section._a7Modal;

    opener?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      openModal(modal, opener);
    });

    modal?.querySelectorAll('[data-a7-rigor-close]').forEach((closer) => {
      closer.addEventListener('click', (event) => {
        event.preventDefault();
        closeModal(modal);
      });
    });

    portalModalToBody(section);
    updateProductButtonVisibility(section);
  };

  const updateAllProductButtons = () => {
    document.querySelectorAll('[data-a7-rigor-product-section]').forEach((section) => {
      bindProductSection(section);
      updateProductButtonVisibility(section);
    });
  };

  const scheduleProductButtonUpdate = () => {
    clearTimeout(window._a7RigorUpdateTimer);
    window._a7RigorUpdateTimer = setTimeout(updateAllProductButtons, 20);
    setTimeout(updateAllProductButtons, 160);
    setTimeout(updateAllProductButtons, 500);
  };

  updateAllProductButtons();

  document.addEventListener('change', (event) => {
    if (event.target.matches('input[name^="options["], select[name^="options["]')) {
      scheduleProductButtonUpdate();
    }
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('.swatch-element, product-swatch, [data-option-value]')) {
      scheduleProductButtonUpdate();
    }
  });

  document.addEventListener('shopify:section:load', scheduleProductButtonUpdate);

  const observeProductRoots = () => {
    document.querySelectorAll('product-information').forEach((productRoot) => {
      if (productRoot.dataset.a7RigorObserved === 'true') return;
      productRoot.dataset.a7RigorObserved = 'true';

      const observer = new MutationObserver(() => {
        clearTimeout(productRoot._a7RigorTimer);
        productRoot._a7RigorTimer = setTimeout(updateAllProductButtons, 60);
      });

      observer.observe(productRoot, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'checked', 'aria-checked']
      });
    });
  };

  observeProductRoots();
  document.addEventListener('shopify:section:load', observeProductRoots);


  const closePromo = (modal) => {
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('a7-rigor-modal-open');
  };

  const openPromo = (section) => {
    const modal = section.querySelector('[data-a7-rigor-promo-modal]');
    if (!modal) return;
    modal.hidden = false;
    document.body.classList.add('a7-rigor-modal-open');
    requestAnimationFrame(() => modal.querySelector('.a7-rigor-promo-modal__dialog')?.focus());
  };

  const initPromoSection = (section) => {
    if (!section || section.dataset.a7PromoBound === 'true') return;
    section.dataset.a7PromoBound = 'true';
    const promo = section.querySelector('[data-a7-rigor-promo-modal]');
    const calculator = section.querySelector('[data-a7-rigor-modal]');
    if (calculator && calculator.parentElement !== document.body) document.body.appendChild(calculator);
    if (promo && promo.parentElement !== document.body) document.body.appendChild(promo);

    promo?.querySelectorAll('[data-a7-rigor-promo-close]').forEach((button) => {
      button.addEventListener('click', () => closePromo(promo));
    });

    promo?.querySelector('[data-a7-rigor-promo-calculator-open]')?.addEventListener('click', (event) => {
      closePromo(promo);
      openModal(calculator, event.currentTarget);
    });

    const mode = section.dataset.popupMode || 'session';
    const key = section.dataset.storageKey || 'a7-rigor-promo';
    let alreadyShown = false;
    try { alreadyShown = mode === 'session' && sessionStorage.getItem(key) === '1'; } catch (_) {}
    if (!alreadyShown) {
      const delay = Number(section.dataset.popupDelay || 0);
      window.setTimeout(() => {
        openPromo(section);
        try { if (mode === 'session') sessionStorage.setItem(key, '1'); } catch (_) {}
      }, delay);
    }
  };

  const initAllPromos = () => document.querySelectorAll('[data-a7-rigor-promo-section]').forEach(initPromoSection);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAllPromos);
  else initAllPromos();
  document.addEventListener('shopify:section:load', (event) => initPromoSection(event.target.querySelector('[data-a7-rigor-promo-section]')));


  const getProductFormRoot = (form) =>
    form.closest('product-information') ||
    form.closest('[data-product-content-wrapper]') ||
    form.closest('.product-single-wrapper') ||
    document;

  const readOptionValue = (productRoot, optionMatcher) => {
    for (const swatch of productRoot.querySelectorAll('product-swatch')) {
      const label = swatch.querySelector('.label-font');
      const optionName = label?.dataset.option || label?.textContent?.split(':')[0] || '';
      if (!optionMatcher(optionName)) continue;

      const labelledValue = label?.textContent?.split(':').slice(1).join(':').trim();
      if (labelledValue) return labelledValue;

      const checked = swatch.querySelector('input:checked');
      if (checked) return checked.value || checked.dataset.value || '';

      const active = swatch.querySelector('.swatch-element.active, [aria-checked="true"]');
      if (active) return active.dataset.value || active.querySelector('input')?.value || active.textContent || '';
    }

    for (const input of productRoot.querySelectorAll('input[name^="options["]:checked')) {
      const name = input.name.match(/^options\[(.+)\]$/i)?.[1] || '';
      if (optionMatcher(name)) return input.value || input.dataset.value || '';
    }

    for (const select of productRoot.querySelectorAll('select[name^="options["]')) {
      const name = select.name.match(/^options\[(.+)\]$/i)?.[1] || '';
      if (optionMatcher(name)) return select.value || '';
    }

    return '';
  };

  const removeRecommendationProperties = (form) => {
    form.querySelectorAll('input[data-a7-rigor-order-property]').forEach((input) => input.remove());
  };

  const setRecommendationProperty = (form, propertyName, value) => {
    let input = form.querySelector(`input[data-a7-rigor-order-property][name="properties[${propertyName}]"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${propertyName}]`;
      input.dataset.a7RigorOrderProperty = 'true';
      form.appendChild(input);
    }
    input.value = String(value ?? '');
  };

  const syncRecommendationProperties = (form) => {
    if (!form?.matches('form[data-type="add-to-cart-form"]')) return;

    const recommendation = getStoredRecommendation();
    const productRoot = getProductFormRoot(form);
    const stiffness = readOptionValue(productRoot, optionNameIsStiffness);
    const selectedSize = readOptionValue(productRoot, (name) => normaliseOptionText(name) === 'size');

    if (!recommendation || !isRigorValue(stiffness, 'Rigor Mortis')) {
      removeRecommendationProperties(form);
      return;
    }

    setRecommendationProperty(form, '_a7_recommended_size', recommendation.recommendedSize);
    setRecommendationProperty(form, '_a7_selected_size_at_add', selectedSize);
    setRecommendationProperty(form, '_a7_reason', recommendation.reason);
    setRecommendationProperty(form, '_a7_knee_cm', recommendation.knee);
    setRecommendationProperty(form, '_a7_quad_cm', recommendation.quad);
    setRecommendationProperty(form, '_a7_calf_cm', recommendation.calf);
    setRecommendationProperty(form, '_a7_competition_fit', recommendation.competitionFit || '');
    setRecommendationProperty(form, '_a7_recommendation_source', recommendation.source || '');
    setRecommendationProperty(form, '_a7_recommendation_time', new Date(recommendation.createdAt).toISOString());
    setRecommendationProperty(form, '_a7_recommender_version', recommendation.recommenderVersion || RECOMMENDER_VERSION);
  };

  const syncAllRecommendationProperties = () => {
    document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(syncRecommendationProperties);
  };

  const scheduleRecommendationPropertySync = () => {
    clearTimeout(window._a7RigorPropertyTimer);
    window._a7RigorPropertyTimer = setTimeout(syncAllRecommendationProperties, 20);
    setTimeout(syncAllRecommendationProperties, 160);
    setTimeout(syncAllRecommendationProperties, 500);
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[data-type="add-to-cart-form"]');
    if (form) syncRecommendationProperties(form);
  }, true);

  document.addEventListener('click', (event) => {
    if (event.target.closest('.shopify-payment-button, .shopify-payment-button__button')) {
      syncAllRecommendationProperties();
    }
    if (event.target.closest('.swatch-element, product-swatch, [data-option-value]')) {
      scheduleRecommendationPropertySync();
    }
  }, true);

  document.addEventListener('change', (event) => {
    if (event.target.matches('input[name^="options["], select[name^="options["]')) {
      scheduleRecommendationPropertySync();
    }
  });

  document.addEventListener('a7:rigor-recommendation', scheduleRecommendationPropertySync);
  document.addEventListener('shopify:section:load', scheduleRecommendationPropertySync);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAllRecommendationProperties);
  } else {
    syncAllRecommendationProperties();
  }

})();
